import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource/geist-mono";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ContextMenuProvider } from "mantine-contextmenu";
import { AlertModalProvider } from "./AlertModal";
import ColorThemeProvider from "./ColorThemeProvider";
import { installBackendAuth } from "./backend/sessionToken";

// Before anything talks to the server: requests to it must carry the session
// token, or it refuses them. See backend/sessionToken.ts.
installBackendAuth();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ColorThemeProvider>
      <AlertModalProvider>
        <ContextMenuProvider>
          <App />
        </ContextMenuProvider>
      </AlertModalProvider>
    </ColorThemeProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
